<template>
<div>
  <p style="text-align:center;font-size:110%;background:#F44336;color:#fff;margin:0;padding:2px;">
    令和も対応しました！！
  </p>
  <v-toolbar color="white" flat :class="{top: isTop}">
    <v-subheader class="pageTitle headline">
      <router-link :to="{ name: 'Index'}" :class="{top: isTop}">
        <img src="/static/image/logo.png" style="margin-top:5px;height:40px;">
      </router-link>
    </v-subheader>
      <v-spacer></v-spacer>
        <!-- <v-btn @click="drawer=!drawer" color="white" icon :class="{top: isTop}"><v-icon large>more_vert</v-icon></v-btn> -->
        <div v-if="isLogin">
          <v-btn color="red" flat large style="padding:0!important;margin:6px 0;" :class="{top: isTop}" @click="onEdit"><v-icon>edit</v-icon>投稿</v-btn>
          <v-btn color="white" icon large style="padding:0!important;margin:6px 0;" :class="{top: isTop}" class="red--text" @click="drawer=!drawer"><v-icon>menu</v-icon></v-btn>
        </div>
        <v-btn v-else :to="{ name: 'Login'}" flat :class="{top: isTop}"><v-icon large>person</v-icon>ログイン</v-btn>
  </v-toolbar>
  <v-navigation-drawer v-model="drawer" app clipped width="300" right>
     <v-subheader class="blue-grey lighten-5">
       <img src="@/assets/image/japan-min.png" style="height:30px;margin-left:10px;">
     </v-subheader>
        <v-list-tile v-if="isLogin" avatar :to="{ name: 'Profile', params: {id: uid}}">
          <v-list-tile-avatar><img :src="profileImageUrl"></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title>マイページ</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile avatar @click="onEdit">
          <v-list-tile-avatar><v-icon>edit</v-icon></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title>平成年表を投稿</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile avatar @click="onView">
          <v-list-tile-avatar><v-icon>search</v-icon></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title>投稿を見る</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile avatar @click="onAbout">
          <v-list-tile-avatar><v-icon>help</v-icon></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title>平成年表とは</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile avatar @click="onTop">
          <v-list-tile-avatar><v-icon>home</v-icon></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title>トップページ</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
      <v-list v-if="isLogin">  <!-- ログイン済のメニュー -->
        <!-- <v-list-tile avatar>
          <v-list-tile-avatar><v-icon>list</v-icon></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title>投稿一覧</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider> -->
        <v-list-tile avatar @click="signout">
          <v-list-tile-content><v-list-tile-title>ログアウト</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list v-else>  <!-- 未ログインのメニュー -->
        <v-list-tile avatar :to="{ name: 'Login'}">
          <v-list-tile-avatar><v-icon>home</v-icon></v-list-tile-avatar>
          <v-list-tile-content><v-list-tile-title>ログイン</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile :to="{ name: 'Kiyaku'}">
          <v-list-tile-content><v-list-tile-title>利用規約</v-list-tile-title></v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSdYvwyS9RtSybs57SdJLEkZ-9selzeISazH3ATalnZhfYm01Q/viewform" target="_blank">
          <v-list-tile-content><v-list-tile-title>運営へのお問い合わせ</v-list-tile-title></v-list-tile-content>
          </a>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeF4VKKoa3hjbfja_1r1BAvurCPhCRMu_n6Rkh3wVyoFmghyg/viewform" target="_blank">
          <v-list-tile-content><v-list-tile-title>要望・不具合のご連絡</v-list-tile-title></v-list-tile-content>
          </a>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-tile>
          <a href="https://twitter.com/katsuo_s7" target="_blank">
          <v-list-tile-content><v-list-tile-title>運営者</v-list-tile-title></v-list-tile-content>
          </a>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list-tile avatar @click="drawer=!drawer" class="blue-grey lighten-5">
        <v-list-tile-content><v-list-tile-title style="text-align:right">メニューを閉じる</v-list-tile-title></v-list-tile-content>
        <v-list-tile-avatar><v-icon>keyboard_arrow_right</v-icon></v-list-tile-avatar>
      </v-list-tile>
  </v-navigation-drawer>
</div>
</template>

<script>
import { db } from '../../main'
import firebase from 'firebase'
export default {
  name: 'CommonHeader',
  props: {
    sheen: String
  },
  data () {
    return {
      user: {},
      drawer: false
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.view.isLogin
    },
    profileImageUrl () {
      return this.$store.state.view.profileImageUrl
    },
    uid () {
      return firebase.auth().currentUser.uid
    },
    isTop () {
      if (this.sheen === undefined) {
        return false
      } else if (this.sheen === '') {
        return false
      } else if (this.sheen === 'top') {
        return true
      }
      return false
    }
  },
  mounted () {
    if (!this.isLogin) {
      this.getUserInfo()
    }
  },
  methods: {
    getUserInfo: function () {
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          this.$store.commit('view/login')
          db.collection('user').doc(user.uid).get().then((doc) => {
            if (doc.exists) {
              this.user = doc.data()
              this.$store.commit('view/setProfileImegeUrl', this.user.photoURL)
              this.$store.commit('view/setDisplayName', this.user.displayName)
            } else {
              this.isError = true
              this.errorMessage = '存在しないURLです。'
            }
          })
        }
      }.bind(this))
    },
    signout: function () {
      firebase.auth().signOut().then(() => {
        this.$store.commit('view/logout')
        alert('ログアウトしました。')
      })
    },
    onLogin () {
      this.drawer = false
      this.$router.push({name: 'Login'})
    },
    onEdit () {
      this.drawer = false
      this.$router.push({name: 'Edit', params: {obj: {mode: 'new'}}})
    },
    onView () {
      this.drawer = false
      this.$router.push({name: 'View'})
    },
    onTop () {
      this.drawer = false
      this.$router.push({name: 'Index'})
    },
    onAbout () {
      this.drawer = false
      this.$router.push({name: 'Lp'})
    }
  }
}
</script>

<style scoped>
@import url("../../assets/css/common.css");
#header-wrapper{
  width: 100%;
  height: 80px;
  background-color: #ECEFF1;
}
#header{
  width: 100%;
  max-width: 1000px;
  margin: 10px auto;
}
.pageTitle{
  color: black;
}
a{
  text-decoration: none !important;
  color: black;
}
.v-subheader{
  padding:0 !important;
}
.top{
  background-color: #D51522 !important;
  color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/CommomHeader.vue